import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { font16, font30 } from 'approot/shared/styles/typography.style';
import {
  baseFlexCss,
  flexCentreAlignCss,
} from 'approot/shared/styles/flex.style';
import { ImageThumbnailWrapper } from 'approot/shared/images/images.style';
import {
  grey1,
  grey2,
  grey4,
  grey5,
  purple6,
} from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const VocabularyImage = styled.div`
  ${ImageThumbnailWrapper} {
    height: ${rem(128)};
    width: ${rem(128)};
    ${mediaUp.md`
       height: ${rem(288)};
       width:${rem(288)};
    `}
  }
`;

export const VocabularyEmptyImage = styled.div`
  ${flexCentreAlignCss}
  background-color: ${grey2};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  height: ${rem(128)};
  width: ${rem(128)};
  flex-shrink: 0;

  ${mediaUp.md`
    height: ${rem(288)};
    width:${rem(288)};
  `}

  svg path {
    stroke: ${grey5};
  }
`;

export const VocabularyExamples = styled.div`
  ${flexCentreAlignCss}
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  position: relative;
  padding: 0 ${rem(spacing24)};
  width: 100%;
`;

export const VocabularyExampleInfo = styled.div`
  ${baseFlexCss}
`;

export const VocabularyExampleList = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  padding: ${rem(spacing24)} 0;
  -webkit-overflow-scrolling: touch;
  width: 100%;

  ${VocabularyExampleInfo} {
    flex: 0 0 100%;
    scroll-snap-align: center;
  }
`;

export const VocabularyExampleText = styled.p`
  ${font16}

  ${mediaUp.md`
    ${font30}
  `}
  padding: 0 ${rem(spacing16)};
`;

export const VocabularyDots = styled.div`
  padding: ${rem(spacing16)} 0;
  text-align: center;
`;

type CarouseDotProps = {
  $isActive?: boolean;
};
export const VocabularyDot = styled.span<CarouseDotProps>`
  background-color: ${props => (props.$isActive ? purple6 : grey4)};
  border-radius: ${rem(borderRadius8)};
  display: inline-block;
  height: ${rem(12)};
  margin: 0 ${rem(6)};
  width: ${rem(12)};
`;
